// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"388":"universities-page","426":"courses-page","847":"programs-page","984":"leads-page"}[chunkId] + "." + {"388":"f23cd817","426":"f23cd817","847":"f23cd817","984":"f23cd817"}[chunkId] + ".css";
};